<template>
  <b-container class="Tachi15ContactForm">
    <b-form>
      <b-form-group
        id="input-group-name"
        label="1 - Company / project name ?"
        label-for="input-name"
      >
        <b-form-input
          id="input-name"
          v-model="form.name"
          required
          placeholder="Enter name"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-email"
        label="2 - Your email address ?"
        label-for="input-email"
      >
        <b-form-input
          id="input-email"
          v-model="form.email"
          type="email"
          required
          placeholder="Enter email"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-innovation-type"
        label="3 - Nature of your innovation ?"
        label-for="input-innovation-type"
      >
        <b-form-select
          id="input-innovation-type"
          v-model="form.innovationType"
          :options="innovationTypes"
          required
        ></b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-location"
        label="4 - Country of head office ?"
        label-for="input-location"
      >
        <b-form-select
          id="input-location"
          v-model="form.location"
          :options="locations"
          required
        ></b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-date"
        label="5 - Date of incorporation ?"
        label-for="input-date"
      >
        <b-form-input
          id="input-date"
          type="date"
          v-model="form.date"
          required
          placeholder="Enter date"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-desciption"
        label="6 - Please provide a concise description of your startup (150 words max):"
        label-for="input-desciption"
      >
        <b-form-textarea
          id="input-desciption"
          v-model="form.description"
          required
          placeholder="Type your answer here..."
        ></b-form-textarea>
      </b-form-group>
      <div class="wrap">
        <b-button
          @click.prevent="submitForm"
          type="submit"
          class="button"
          v-if="!submitted"
          >Submit</b-button
        >
        <b-button v-if="submitted" class="button" disabled>Thank you</b-button>
      </div>
    </b-form>
  </b-container>
</template>

<script src="https://smtpjs.com/v3/smtp.js">
</script>

<script>
import RedButton from "./Reusable/RedButton.vue";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        innovationType: null,
        location: null,
        date: null,
        description: ""
      },
      innovationTypes: [
        { text: "Select One", value: null },
        "Artificial Intelligence",
        "Blockchain",
        "Entreprise Software",
        "Other"
      ],
      locations: ["Japan", "outside Japan"],
      show: true,
      submitted: false
    };
  },

  methods: {
    submitForm() {
      console.log(this.form);
      if (true) {
        emailjs
          .send(
            "gmail",
            "template_e8vZgPKT",
            this.form,
            "user_cNj3jqxI1UV5gnHctQNhf"
          )
          .then(
            response => {
              console.log("SUCCESS!", response.status, response.text);
              this.submitted = true;
            },
            function(error) {
              console.log("FAILED...", error);
            }
          );
      }
    },
    resetForm() {
      this.form = {
        name: "",
        email: "",
        innovationType: null,
        location: null,
        date: null,
        description: ""
      };
    }
  }
};
</script>

<style scoped>
.Tachi15ContactForm {
  padding: 30px 0;
}

.form-group {
  padding: 5px;
}

.wrap {
  display: flex;
  justify-content: center;
  padding: 30px;
}

.btn {
  background-color: #e74c3c;
  color: #ffffff;
  border: 0px solid #212f3d;
  text-transform: uppercase;
  text-decoration: none;
  padding: 15px 40px;
  border-radius: 100px;
  transition: all 0.2s;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  background-color: #e74c3c;
}

.btn:active {
  background-color: #e74c3c !important;
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}
</style>
